// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__M_jDR","containerItemsCenter":"Skeleton_containerItemsCenter__136mp"};